import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/close-icon-2.svg'


const _hoisted_1 = { class: "w-full h-screen fixed top-0 left-0 bg-black/75 z-[1000]" }
const _hoisted_2 = { class: "w-[588px] min-h-[458px] px-[20px] fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-[7px] bg-white z-[1000]" }
const _hoisted_3 = { class: "flex items-center justify-between py-[16px] mb-[16px] border-b border-[#E3E1EA]" }
const _hoisted_4 = { class: "mb-[24px]" }
const _hoisted_5 = { class: "mb-[6px] text-[16px] text-[#898790]" }
const _hoisted_6 = { class: "relative w-full" }
const _hoisted_7 = { class: "max-h-[300px] overflow-y-auto" }
const _hoisted_8 = { class: "mb-[24px]" }
const _hoisted_9 = { class: "mb-[6px] text-[16px] text-[#898790]" }
const _hoisted_10 = { class: "relative w-full" }
const _hoisted_11 = { class: "max-h-[300px] overflow-y-auto" }
const _hoisted_12 = { class: "pb-[16px] border-b border-[#E3E1EA]" }
const _hoisted_13 = { class: "mb-[6px] text-[16px] text-[#898790]" }
const _hoisted_14 = { class: "relative w-full" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = {
  key: 0,
  class: "text-sm text-red-400 font-medium mt-1"
}
const _hoisted_17 = { class: "py-[12px] flex items-center justify-end" }
const _hoisted_18 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_19 = { key: 1 }

import { ref, reactive, computed } from "vue";
import { useTranslate } from "@/composables/useTranslate";
import SelectMenu from "../Re-usable/SelectMenu.vue";
import SpinnerLoader from "../Loaders/SpinnerLoader.vue";

type Props = {
  isReportDialogOpen: boolean;
  selectedMonth: any;
  selectedYear: any;
  selectedUrl: any;
  months: any;
  years: any;
  isEdit: boolean;
  isLoading: boolean;
};

type Emits = {
  (event: "onClose"): void;
  (event: "increaseDialogStage"): void;
  (event: "onSubmitBonus", month: string, year: string, url: string): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'BonusReportForm',
  props: {
    isReportDialogOpen: { type: Boolean },
    selectedMonth: {},
    selectedYear: {},
    selectedUrl: {},
    months: {},
    years: {},
    isEdit: { type: Boolean },
    isLoading: { type: Boolean }
  },
  emits: ["onClose", "increaseDialogStage", "onSubmitBonus"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const selectedMonth = ref(props.selectedMonth);
const selectedYear = ref(props.selectedYear);
const selectedUrl = ref(props.selectedUrl);
const isLoading = computed(() => props.isLoading);

const emits = __emit;
const { t } = useTranslate();

const errors = reactive({
  selectedUrl: "",
});

const validate = () => {
  let isValid = [];
  errors.selectedUrl = "";

  if (!selectedUrl.value) {
    errors.selectedUrl = t("installers.enter_report_url").value;
    isValid.push(false);
  } else {
    isValid.push(true);
    errors.selectedUrl = "";
  }

  return isValid.filter((item: boolean) => !item).length === 0;
};

const onSubmit = async () => {
  if (!validate()) return;

  emits(
    "onSubmitBonus",
    selectedMonth.value,
    selectedYear.value,
    selectedUrl.value
  );
};

const handleClose = () => {
  emits("onClose");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "nested" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "custom-header"),
            _createElementVNode("img", {
              class: "h-[12px] w-[12px] cursor-pointer",
              src: _imports_0,
              alt: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClose()))
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("installers.choose_month")), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(SelectMenu, {
                    modelValue: selectedMonth.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedMonth).value = $event)),
                    options: __props.months,
                    disabled: __props.isEdit
                  }, null, 8, ["modelValue", "options", "disabled"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)("installers.choose_year")), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(SelectMenu, {
                    modelValue: selectedYear.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedYear).value = $event)),
                    options: __props.years,
                    disabled: __props.isEdit
                  }, null, 8, ["modelValue", "options", "disabled"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)("installers.report_url")), 1),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedUrl).value = $event)),
                  placeholder: _unref(t)('installers.add_link').value,
                  class: "w-full appearance-none outline-none rounded-[6px] bg-[#F9F8F6] p-[12px]"
                }, null, 8, _hoisted_15), [
                  [_vModelText, selectedUrl.value]
                ]),
                (errors.selectedUrl)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(errors.selectedUrl), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              onClick: onSubmit,
              class: "w-[150px] flex items-center justify-center p-[12px] gap-[8px] text-[16px] text-white font-semibold bg-[#393840] rounded-[7px]"
            }, [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createVNode(SpinnerLoader)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(t)("global.upload")), 1))
            ])
          ])
        ])
      ])
    ]),
    _: 3
  }))
}
}

})